import { Link } from "react-router-dom";
import { BRAND } from "@/lib/config";
import { Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer id="contact" className="mt-24 bg-[color:var(--brand-ink)] text-[color:var(--brand-cream)]">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-4">
            <img src="/logo.jpeg" alt="Bawajii Travels & Infra" className="h-16 w-16 rounded-full object-cover ring-1 ring-white/20" />
            <div className="font-display text-3xl">{BRAND.name}</div>
          </div>
          <p className="mt-4 text-[color:var(--brand-cream)]/70 max-w-md leading-relaxed">
            Trusted travel partner for local rides, outstation trips, and airport transfers.
            Comfortable fleet, transparent fares, drivers you can trust.
          </p>
        </div>
        <div>
          <div className="uppercase text-xs tracking-widest text-[color:var(--brand-cream)]/50 mb-3">Reach us</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2"><Phone className="h-4 w-4" /> {BRAND.phone}</li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4" /> {BRAND.email}</li>
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5" /> <span>{BRAND.address}</span></li>
          </ul>
        </div>
        <div>
          <div className="uppercase text-xs tracking-widest text-[color:var(--brand-cream)]/50 mb-3">Company</div>
          <ul className="space-y-2 text-sm">
            <li><a href="#about" className="hover:text-[color:var(--brand-amber)] transition-colors">About</a></li>
            <li><a href="#services" className="hover:text-[color:var(--brand-amber)] transition-colors">Services</a></li>
            <li><a href="#fleet" className="hover:text-[color:var(--brand-amber)] transition-colors">Fleet</a></li>
            <li><a href="#routes" className="hover:text-[color:var(--brand-amber)] transition-colors">Popular Routes</a></li>
            <li>
              <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-[color:var(--brand-amber)] transition-colors">Admin Login</Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 py-6 text-xs text-[color:var(--brand-cream)]/50">
          © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
